module.exports = __webpack_public_path__ + "img/clothing119.27010237.jpg";